import app from '../../../scripts/app';
import template from './cadastral-number-segment.jade';
import validation from '../../../scripts/services/validation';

import { initializeHintClickTracking } from '../../../scripts/utils/hint-tracking';

app.directive('cianAfCadastralNumberSegment', [() => ({
    template,
    scope: {},
    bindToController: {
        ad: '=',
        form: '=',
    },
    controller: ['analyticsService', 'deviceService', function (analyticsService, deviceService) {
        this.isMobile = deviceService.isMobile;
        this.validation = validation(this.form, 'cadastralNumber', {
            maxlength: 'Допустимо не более 30 символов',
        });
        this.tooltipText = 'Номер в формате 47:14:1203001:814.<br/>Указан в Свидетельстве о собственности.';

        this.unsubscribeHintListener = null;
        this.isHintTrackingInitialized = false;

        setTimeout(() => this.unsubscribeHintListener = initializeHintClickTracking('cadastral-hint', analyticsService.adAnalyticsCategory), 0);

        $scope.$on('$destroy', () => {
          if (this.unsubscribeHintListener) {
            this.unsubscribeHintListener();
          }
        });
    }],
    controllerAs: '$ctrl',
    replace: true,
})]);
